import React, { PropsWithChildren, useContext } from "react";
import { KnopClientProvider } from "./KnopClientProvider";
import { KnopHttpClient } from "@opstel/query/knopHttpClient";
import { ReactAppContext } from "@opstel/reactApp/ReactAppContext";
import { config } from "@shared/envVariables";
import { OpstelApiClient } from "@opstel/query/v2/opstelClient";
import { OpstelClientProvider } from "../opstelClient/OpstelClientProvider";

export function KnopHttpClientProvider({
  children,
}: Readonly<PropsWithChildren>): React.JSX.Element {
  const knopReactApp = useContext(ReactAppContext);
  if (!knopReactApp) {
    return <div>Kan geen access token ophalen</div>;
  }

  const knopClient = new KnopHttpClient(config.opstel.apiBaseUrl, knopReactApp);
  const opstelClient = new OpstelApiClient(`${config.opstel.apiBaseUrl}/bff/v2`, knopReactApp);

  return (
    <KnopClientProvider knopClient={knopClient}>
      <OpstelClientProvider opstelClient={opstelClient}>{children}</OpstelClientProvider>
    </KnopClientProvider>
  );
}
